"use client"

import { useState } from "react"
import { Phone, Mail, MapPin, PlusIcon, ArrowDown01Icon, ArrowDownIcon, X } from "lucide-react"

interface FooterData {
    companyName: string
    cnpj: string
    address: string
    phone: string
    email: string
}

export function Footer() {

    const [footerData, setFooterData] = useState<FooterData>({
        companyName: "",
        cnpj: "",
        address: "",
        phone: "",
        email: "",
    })

    const [tempData, setTempData] = useState<FooterData>(footerData);

    (window as any).handleEditFooter = async (data: any) => {

        const footerData: FooterData = {
            companyName: data.name,
            cnpj: data.cnpj,
            address: data.address,
            phone: data.phone,
            email: data.email,
        };

        setFooterData(footerData) // ← change this line
    };

    const handleChange = (field: keyof FooterData, value: string) => {
        setTempData((prev) => ({ ...prev, [field]: value }))
    }

    return (
        <footer id="footer-iframe" className="bg-secondary mirror text-primary absolute bottom-0 w-full h-[135px] z-[1000000000000] overflow-y-auto !border-none">

            <div className="h-full flex flex-col items-center justify-center relative text-center">

                <button id="close-iframe-footer" className="rounded-lg absolute top-2 right-[80px] md:right-2 bg-primary text-background p-1">
                    <X></X>
                </button>

                {/* CONTATO */}
                <div className="flex flex-col gap-2 mb-4">
                    <h3 className="text-md font-semibold">Contato</h3>

                    {footerData.phone &&
                        <div className="flex items-center justify-center gap-3">
                            <Phone size={18} />
                            <span>{footerData.phone}</span>
                        </div>
                    }

                    {footerData.email &&
                        <div className="flex items-center justify-center gap-3">
                            <Mail size={18} />
                            <span>{footerData.email}</span>
                        </div>
                    }
                </div>

                {/* INSTITUCIONAL */}
                <div className="flex flex-col gap-2">
                    <h3 className="text-md font-semibold">Institucional</h3>

                    {footerData.cnpj &&
                        <p>CNPJ: {footerData.cnpj}</p>
                    }

                    {footerData.address &&
                        <div className="flex items-center justify-center gap-3">
                            <MapPin size={18} />
                            <span>{footerData.address}</span>
                        </div>
                    }
                </div>

            </div>

            {/* COPYRIGHT */}
            <div className="border-t border-zinc-200 py-2 text-center text-sm text-primary w-full fixed bottom-0">
                © {new Date().getFullYear()} {footerData.companyName}. Todos os direitos reservados.
            </div>

        </footer>
    )
}
